import { createGraphiQLFetcher } from '@graphiql/toolkit';
import GraphiQL from 'graphiql';
import 'graphiql/graphiql.css';
import html2canvas from 'html2canvas';
import React from 'react';
import ReactDOM, { createRoot } from 'react-dom/client';
import Sonner, { NotificationType } from './components/sonner';
import Playground from './playgrounds/playground';

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.reveal')) {
    import('./public').then((m) => m.init());
  }

  if (document.querySelector('[data-chart]')) {
    import('./charts').then((m) => m.init());
  }

  if (document.querySelector('[data-program-builder]')) {
    import('./program-builder').then((m) => m.init());
  }

  document.querySelectorAll('#playground').forEach((element) => {
    const react = ReactDOM.createRoot(element);
    react.render(<Playground />);
  });
  document.querySelectorAll('[data-control]').forEach(function (item) {
    switch ((item as HTMLElement).dataset.control) {
      case 'dependent-select': {
        const options = JSON.parse((item as HTMLElement).dataset.options!!);
        const parent = item.querySelector('[data-target="parent"]') as HTMLSelectElement;

        const updateChildren = () => {
          const children = item.querySelector('[data-target="child"]') as HTMLSelectElement;
          const html = (options[parent.value] || [])
            .map((option: [string, string]) => `<option value="${option[0]}">${option[1]}</option>`)
            .join('');
          children.innerHTML = html;

          const savedParentId = (children.getAttribute('data-selected') || '').toString();
          if (savedParentId) {
            children.value = savedParentId;
          }
        };

        parent.addEventListener('change', updateChildren);

        updateChildren();
        break;
      }
      case 'quest-rules': {
        const container = item as HTMLElement;

        const list = container.querySelector('[data-target="list"]') as HTMLElement;
        const template = container.querySelector('template[data-target="template"]') as HTMLTemplateElement;
        const addBtn = container.querySelector('[data-action="add-rule"]') as HTMLButtonElement;

        const uniqueIndex = () => (Date.now() + Math.floor(Math.random() * 10000)).toString();

        const wireRemoveButton = (row: HTMLElement) => {
          const removeBtn = row.querySelector('[data-action="remove-rule"]') as HTMLButtonElement | null;
          if (!removeBtn) return;
          removeBtn.addEventListener('click', () => {
            const destroyInput = row.querySelector('input[name*="[_destroy]"]') as HTMLInputElement | null;
            if (destroyInput) destroyInput.value = '1';
            row.style.display = 'none';
          });
        };

        // wire existing rows
        list.querySelectorAll<HTMLElement>('.grid').forEach(wireRemoveButton);

        // handle add
        addBtn?.addEventListener('click', () => {
          const html = template.innerHTML.replaceAll('NEW_RECORD', uniqueIndex());
          const wrapper = document.createElement('div');
          wrapper.innerHTML = html.trim();
          const newRow = wrapper.firstElementChild as HTMLElement;
          list.appendChild(newRow);
          wireRemoveButton(newRow);
        });

        break;
      }
      case 'copy-to-clipboard': {
        item.addEventListener('click', () => {
          navigator.clipboard.writeText((item.querySelector('input') as HTMLInputElement).value);
          const react = ReactDOM.createRoot(document.querySelector('#root')!!);
          react.render(<Sonner message="Copied to clipboard!" notificationType="info" />);
        });

        break;
      }
      case 'confirm': {
        item.addEventListener('click', function (event) {
          var confirmation = confirm((item as HTMLElement).dataset.message);

          if (!confirmation) {
            event.preventDefault();
          }
        });

        break;
      }
      case 'form': {
        (item as HTMLFormElement).addEventListener('submit', () => {
          (item.querySelector('input[type="submit"]') as HTMLInputElement).disabled = true;
        });

        break;
      }
      case 'show-options': {
        item.addEventListener('click', () => {
          item.querySelector('[data-target="show-options"]')?.classList.toggle('hidden');
        });

        break;
      }
      case 'slider': {
        item.addEventListener('input', (event) => {
          const progress =
            (Number((event.target as HTMLInputElement).value) / Number((item as HTMLInputElement).max)) * 100;
          (item as HTMLInputElement).style.background =
            `linear-gradient(to right, hsl(var(--primary)) ${progress}%, hsl(var(--secondary)) ${progress}%)`;
        });

        break;
      }
      case 'sonner': {
        const react = ReactDOM.createRoot(item);
        react.render(
          <Sonner
            message={(item as HTMLElement).dataset.message!!}
            notificationType={(item as HTMLElement).dataset.notificationType as NotificationType}
          />,
        );

        break;
      }
      case 'download-image': {
        html2canvas(document.querySelector('.card')!!).then((canvas) => {
          const data: string = canvas.toDataURL('image/png;base64');
          const downloadLink: HTMLAnchorElement = item.querySelector('#download')!!;

          downloadLink.download = 'filename';
          downloadLink.href = data;
        });
        break;
      }
      case '': {
        break;
      }
      default:
        console.log(`Sorry, we are out of ${(item as HTMLElement).dataset.control}.`);
    }
  });

  const graphiqlRoot = document.getElementById('graphiql');

  if (graphiqlRoot != null) {
    const fetcher = createGraphiQLFetcher({
      url: 'http://localhost:3000/graphql',
      headers: { Authorization: graphiqlRoot.dataset.token!! },
    });

    const root = createRoot(graphiqlRoot);
    root.render(<GraphiQL fetcher={fetcher} />);
  }
});
